<template>
    <div class="enters">
        <div class="lr">
            <el-row :gutter="6">
                <el-col
                v-for="(item, index) in logins"
                :span="item.title=='注册' ? '24' : '12'"
                :key="index"
                >
                    <a 
                    class="item"
                    :class="item.type"
                    :href="item.url"
                    target="_blank"
                    >
                        {{item.title}}
                    </a>
                </el-col>
            </el-row>
        </div>

        <!--
        <div class="ads">
            <a 
            v-for="(item, index) in ads"
            :key="index"
            class="item"
            :href="item.url"
            target="_blank"
            >
                <img :src="item.img" :alt="item.title">
            </a>
        </div>-->

        <div class="guide">
            <a 
            class="item"
            v-for="(item, index) in guide"
            :key="index"
            :href="item.url"
            target="_blank"
            >
                <img :src="item.icon" :alt="item.title" />
                {{item.title}}
            </a>
        </div>
    </div>
</template>

<script>
import CONFIG from '@config/index';

import advBbJpg from '../assets/adv-bb.jpg';
import advCaJpg from '../assets/adv-ca.jpg';

import iconGuide from '../assets/icon/guide.png';
import iconTel from '../assets/icon/tel.png';

export default {
    data: () => ({
        logins: [
            {
                title: '代理机构登录',
                url: CONFIG.head.dljgLoginUrl+'&mRole=agent',
                type: 'primary',
            },
            {
                title: '投标人/供应商登录',
                url: CONFIG.head.tbrLoginUrl,
                type: 'primary',
            },
            {
                title: '专家登录',
                url: CONFIG.head.zjLoginUrl,
                type: 'primary',
            },
            {
                title: '招标人/采购人登录',
                url: CONFIG.head.dljgLoginUrl+'&mRole=tender',
                type: 'primary',
            },
            {
                title: '注册',
                url: '/register?plan=xdyg',
                type: 'info',
            },
        ],

        ads: [
            {
                title: '采购黑名单查询',
                img: advBbJpg,
                url: ''
            },
            {
                title: 'CA统一认证',
                img: advCaJpg,
                url: ''
            }
        ],

        guide: [
            {
                title: '关于我们',
                icon: iconGuide,
                url: '/about'
            },
            {
                title: '办事指南',
                icon: iconTel,
                url: '/guide'
            }
        ],
    }),
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .enters{
        .lr{
            overflow: hidden;
            margin: -3px 0;

            .item{
                display: block;
                width: 100%;
                box-sizing: border-box;
                float: left;
                font-weight: bold;
                color: white;
                padding: 16px 0;
                text-align: center;
                margin: 6px 0;
                box-sizing: border-box;
                border: 1px solid $primaryColor;
                cursor: pointer;
                transition: all .3s;

                &.primary{
                    background: $primaryColor;

                    &:hover{
                        background: $primaryColor9;
                    }
                }

                &.info{
                    background: white;
                    color: $primaryColor;
                    margin-top: 10px;

                    &:hover{
                        background: $primaryColor;
                        color: white;
                    }
                }
            }
        }

        .ads{
            margin-top: 12px;

            .item{
                display: block;
                height: 60px;
                position: relative;
                cursor: pointer;
                overflow: hidden;

                img{
                    width: 100%;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    transition: all .3s;
                }

                &:hover {
                    img{
                        transform: translate(-50%, -50%) scale(1.1);
                    }
                }

                & + .item{
                    margin-top: 12px;
                }
            }
        }

        .guide {
            margin-top: 10px;
            background: white;
            overflow: hidden;

            .item{
                float: left;
                width: 50%;
                font-size: 16px;
                font-weight: bold;
                line-height: 1em;
                padding: 22px 0;
                text-align: center;
                color: #1b1b1b;
                letter-spacing: 1px;
                position: relative;
                cursor: pointer;

                & + .item:before{
                    content: '';
                    display: block;
                    width: 1px; 
                    height: 38px;
                    background: #dbdbdb;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }

                img{
                    vertical-align: middle;
                    width: 26px;
                    height: 26px;
                }

                &:hover{
                    img{
                        transform: scale(1.1);
                        transition: all .3s;
                    }
                }
            }
        }
    }
</style>